<template>
  <Transition name="alarm-fade">
    <div
      v-if="alarmsStore.ringingAlarm"
      class="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-gray-950/95 backdrop-blur-sm">
      <!-- Animated ring icon -->
      <div class="mb-8 relative">
        <div class="animate-ping absolute inset-0 rounded-full bg-red-500 opacity-30"></div>
        <div class="relative w-32 h-32 rounded-full bg-red-600 flex items-center justify-center shadow-2xl">
          <span class="material-symbols-outlined text-white" style="font-size: 4rem">alarm</span>
        </div>
      </div>

      <!-- Alarm info -->
      <div class="text-center mb-12 px-8">
        <p class="text-gray-400 text-lg mb-2">{{ currentTime }}</p>
        <h1 class="text-white text-4xl font-bold">{{ alarmsStore.ringingAlarm.label }}</h1>
      </div>

      <!-- Action buttons -->
      <div class="flex gap-6">
        <button
          @click="snooze"
          class="flex flex-col items-center gap-2 px-8 py-4 rounded-2xl bg-gray-800 hover:bg-gray-700 text-white transition-colors">
          <span class="material-symbols-outlined text-3xl">snooze</span>
          <span class="text-sm">{{
            tt(
              `Snooze (${alarmsStore.ringingAlarm.snoozeDuration}m)`,
              `Dremež (${alarmsStore.ringingAlarm.snoozeDuration} min)`,
            )
          }}</span>
        </button>
        <button
          @click="dismiss"
          class="flex flex-col items-center gap-2 px-8 py-4 rounded-2xl bg-red-600 hover:bg-red-500 text-white transition-colors">
          <span class="material-symbols-outlined text-3xl">close</span>
          <span class="text-sm">{{ tt('Dismiss', 'Opusti') }}</span>
        </button>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { tt } from '../utils/consoleText';
import { formatTime } from '../utils/formatDate';
import { useAlarmsStore } from '../stores/alarms';

const alarmsStore = useAlarmsStore();
const currentTime = ref('');

let clockInterval: ReturnType<typeof setInterval> | null = null;

function updateClock() {
  const now = new Date();
  currentTime.value = formatTime(now, { hour: '2-digit', minute: '2-digit' });
}

onMounted(() => {
  updateClock();
  clockInterval = setInterval(updateClock, 1000);
});

onBeforeUnmount(() => {
  if (clockInterval) clearInterval(clockInterval);
});

async function snooze() {
  if (alarmsStore.ringingAlarm) {
    await alarmsStore.snoozeAlarm(alarmsStore.ringingAlarm.alarmId);
  }
}

function dismiss() {
  alarmsStore.dismissAlarm();
}
</script>

<style scoped>
.alarm-fade-enter-active,
.alarm-fade-leave-active {
  transition: opacity 0.3s ease;
}
.alarm-fade-enter-from,
.alarm-fade-leave-to {
  opacity: 0;
}
</style>
